import React from "react";
import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";

function Contact() {
  return (
    <section
      id="contact"
      className="relative text-gray-900 overflow-hidden 
                 bg-gradient-to-r from-[#0A2A43] via-[#1E90FF] to-[#87CEEB] py-20"
    >
      {/* 🔹 Subtle Circuit Texture */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/circuits.png')] opacity-10"></div>

      {/* 🔹 Static Blue Glow Border */}
      <div className="absolute inset-0 rounded-[50px] border-2 border-blue-400/50 shadow-[0_0_40px_10px_rgba(30,144,255,0.3)] pointer-events-none"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        {/* Title */}
        <motion.h2
          className="text-4xl md:text-5xl font-extrabold text-center text-blue-50 mb-6 drop-shadow-[0_0_10px_rgba(0,153,255,0.5)]"
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Contact <span className="text-blue-200">Us</span>
        </motion.h2>

        <motion.p
          className="text-center text-blue-50/90 mb-12 max-w-2xl mx-auto text-lg"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Let’s connect and discuss how{" "}
          <span className="text-blue-100 font-semibold">
            SPK MAK TECHNOLOGIES
          </span>{" "}
          can help build the future with AI & Robotics.
        </motion.p>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Contact Form */}
          <motion.form
            className="bg-blue-500/30 backdrop-blur-lg text-white p-8 rounded-2xl shadow-lg border border-blue-400/40"
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="mb-6">
              <label className="block text-sm text-blue-100 mb-2">Name</label>
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-4 py-3 rounded-lg bg-blue-400/40 text-white placeholder-blue-100 border border-blue-300 focus:border-white focus:ring-2 focus:ring-blue-200 outline-none transition"
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm text-blue-100 mb-2">Email</label>
              <input
                type="email"
                placeholder="you@example.com"
                className="w-full px-4 py-3 rounded-lg bg-blue-400/40 text-white placeholder-blue-100 border border-blue-300 focus:border-white focus:ring-2 focus:ring-blue-200 outline-none transition"
              />
            </div>
            <div className="mb-6">
              <label className="block text-sm text-blue-100 mb-2">Message</label>
              <textarea
                rows="4"
                placeholder="Write your message..."
                className="w-full px-4 py-3 rounded-lg bg-blue-400/40 text-white placeholder-blue-100 border border-blue-300 focus:border-white focus:ring-2 focus:ring-blue-200 outline-none transition"
              ></textarea>
            </div>
            <motion.button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-400 to-blue-300 text-white py-3 rounded-lg font-semibold shadow-md hover:opacity-90 transition"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Send Message 🚀
            </motion.button>
          </motion.form>

          {/* Contact Info + Map */}
          <motion.div
            className="bg-blue-500/30 backdrop-blur-lg text-white rounded-2xl shadow-lg border border-blue-400/40 p-8 flex flex-col justify-center space-y-6"
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center space-x-4">
              <Phone className="w-8 h-8 text-blue-100" />
              <span className="text-blue-50 text-lg">+91 81147 54472</span>
            </div>
            <div className="flex items-center space-x-4">
              <Mail className="w-8 h-8 text-blue-100" />
              <span className="text-blue-50 text-lg">
                support@spk-mak.com
              </span>
            </div>
            <div className="flex items-start space-x-4">
              <MapPin className="w-8 h-8 text-blue-100 mt-1" />
              <div>
                <span className="text-blue-50 text-lg block">
                  Bhubaneswar, Odisha, India
                </span>
                <p className="text-blue-100 text-sm mt-2">
                  STPI ELITE Tower, Plot no. 2/A, IDCO Industrial Area Gothapatna,
                  Post- Malipada, Bhubaneswar, Odisha 751029
                </p>
              </div>
            </div>

            {/* Google Map Embed */}
            <div className="mt-4 rounded-xl overflow-hidden border border-blue-300/40 shadow-md">
              <iframe
                title="SPK MAK TECHNOLOGIES Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117588.134059887!2d85.7196325!3d20.2725063!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19091b44b4f7a1%3A0x9b08d35c26f51ab3!2sSTPI%20ELITE%20Tower%2C%20IDCO%20Industrial%20Area%2C%20Gothapatna%2C%20Bhubaneswar%2C%20Odisha%20751029!5e0!3m2!1sen!2sin!4v1708615400000!5m2!1sen!2sin"
                width="100%"
                height="250"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
